var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',{staticClass:"mb-5"},[_c('v-col',{staticClass:"pa-0 ma-0",attrs:{"cols":"12"}},[_c('subestipulante-form',{model:{value:(_vm.broker),callback:function ($$v) {_vm.broker=$$v},expression:"broker"}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }